import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [isQuickLinksOpen, setIsQuickLinksOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const calendlyLink = "https://calendly.com/trbai-info";

  const setActiveLink = (link) => {
    if (window.location.pathname !== "/") {
      window.location.href = `/#${link}`;
    }
  };

  const toggleQuickLinksDropdown = () => {
    setIsQuickLinksOpen(!isQuickLinksOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const onBookConsultation = () => {
    if (typeof window.Calendly !== "undefined") {
      window.Calendly.initPopupWidget({ url: calendlyLink });
    } else {
      console.error("Calendly script is not loaded.");
      alert("Calendly is not ready yet. Please try again in a moment.");
    }
  }

  return (
    <Fragment>
      <footer id="footer" className="footer light-background">

        <div className="container footer-top">
          <div className="row gy-4">
            <div className="col-lg-5 footer-consult-section col-md-12 footer-about">
              <a href="index.html" className="logo d-flex align-items-center">
                <span className="sitename">Need a Consultation?</span>
              </a>
              <p>We’re Here to Drive Your IT Business and Digital Transformation Forward!</p>
              <div className="btn-container-center">
                <button className="btn-get-started fadeInRight delay-2s" onClick={onBookConsultation}>Book a Free Session</button>
              </div>
              <div className="social-links d-flex mt-4">
                <a href="https://www.x.com" target="blank"><i className="bi bi-twitter-x"></i></a>
                <a href="https://www.facebook.com"><i className="bi bi-facebook"></i></a>
                <a href="https://www.instagram.com"><i className="bi bi-instagram"></i></a>
                <a href="https://www.linkedin.com"><i className="bi bi-linkedin"></i></a>
              </div>
            </div>

            <div className="col-lg-2 footer-nav-section col-6 footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li onClick={() => setActiveLink("home")}><a href="#home">Home</a></li>
                <li onClick={() => setActiveLink("about")}><a href="#about">About</a></li>
                <li onClick={() => setActiveLink("services")}><a href="#services">Services</a></li>
                <li onClick={() => setActiveLink("domains")}><a href="#domains">Why Us</a></li>
                <li onClick={() => setActiveLink("contact")}><a href="#contact">Contact</a></li>
                <li><Link to="/careers">Careers</Link></li>
              </ul>
            </div>

            <div className="col-lg-2 footer-nav-section col-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><Link to="/service/digital-consultancy">Digital Consultancy</Link></li>
                <li><Link to="/service/resource-augmentation">Resource Augmentation</Link></li>
                <li><Link to="/service/ai">Artificial Intelligence</Link></li>
                <li><Link to="/service/data-science">Data Science & Analytics</Link></li>
                <li><Link to="/service/software-development">Software Development</Link></li>
              </ul>
            </div>
            <div className="mobile-footer mobile-footer-links" onClick={toggleQuickLinksDropdown}>
              <span>
                <button className="dropdown-toggle">
                  Quick Links
                </button>
                <i className="bi bi-chevron-down toggle-dropdown"></i>
              </span>
              {isQuickLinksOpen && (
                <ul className="mobile-dropdown">
                  <li onClick={() => setActiveLink("home")}><a href="#home">Home</a></li>
                  <li onClick={() => setActiveLink("about")}><a href="#about">About</a></li>
                  <li onClick={() => setActiveLink("domains")}><a href="#domains">Why Us</a></li>
                  <li onClick={() => setActiveLink("contact")}><a href="#contact">Contact</a></li>
                  <li><Link to="/careers">Careers</Link></li>
                </ul>
              )}
            </div>
            <div className="mobile-footer" onClick={toggleServicesDropdown}>
              <span>
                <button className="dropdown-toggle">
                  Our Services
                </button>
                <i className="bi bi-chevron-down toggle-dropdown"></i>
              </span>
              {isServicesOpen && (
                <ul className="mobile-dropdown">
                  <li><Link to="/service/digital-consultancy">Digital Consultancy</Link></li>
                  <li><Link to="/service/resource-augmentation">Resource Augmentation</Link></li>
                  <li><Link to="/service/ai">Artificial Intelligence</Link></li>
                  <li><Link to="/service/data-science">Data Science & Analytics</Link></li>
                  <li><Link to="/service/software-development">Software Development</Link></li>
                </ul>
              )}
            </div>

            <div className="col-lg-3 footer-nav-section footer-address-section col-md-12 footer-contact text-center text-md-start">
              <h4>Contact Us</h4>
              <p>2 Bloor Street West</p>
              <p>Toronto, Ontario M4W 3E2</p>
              <p>Canada</p>
              <p className="mt-4"><strong>Phone:</strong> <span>+1 (647) 906-2336</span></p>
              <p><strong>Email:</strong> <span>info@trbai.com</span></p>
            </div>

          </div>
        </div>

        <div className="container copyright text-center mt-4">
          <p>Copyright © <span>{new Date().getFullYear()}</span> <strong className="px-1 sitename">TRB</strong> <span>All Rights Reserved</span></p>
          {/* <div className="credits">
            Designed by <a>TRB Team</a>
          </div> */}
        </div>
      </footer>
      {/* Calendly Badge Widget */}
      <link
        href="https://assets.calendly.com/assets/external/widget.css"
        rel="stylesheet"
      />
      <script
        src="https://assets.calendly.com/assets/external/widget.js"
        type="text/javascript"
        async
      ></script>
    </Fragment>
  );
};

export default Footer;
